<template>
  <button class="theme-toggle" aria-label="切换主题" @click="toggleTheme">
    <svg class="sun-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
      />
    </svg>
    <svg class="moon-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
      />
    </svg>
  </button>
</template>

<script setup>
  import { inject } from 'vue'

  const toggleTheme = inject('toggleTheme')
</script>

<style scoped>
  .theme-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(20px);
    border: 1px solid var(--border-color);
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .theme-toggle:hover {
    background: rgba(99, 102, 241, 0.1);
    border-color: var(--primary);
  }

  .theme-toggle svg {
    width: 20px;
    height: 20px;
    color: var(--text-secondary);
    transition: all 0.3s ease;
  }

  .theme-toggle .sun-icon {
    display: block;
  }

  .theme-toggle .moon-icon {
    display: none;
  }

  [data-theme='dark'] .theme-toggle {
    background: rgba(30, 41, 59, 0.7);
  }

  [data-theme='dark'] .theme-toggle .sun-icon {
    display: none;
  }

  [data-theme='dark'] .theme-toggle .moon-icon {
    display: block;
  }
</style>
